module.exports = __webpack_public_path__ + "static/media/twitter.cce7491e.svg";